import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
// import { AmplitudeService } from 'src/app/_services/amplitude.service';
import * as $ from 'jquery';
declare function ire(string,{}): any;
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    // public amplitudeService: AmplitudeService
    ) { }

  ngOnInit() {
    this.titleService.setTitle('Trinka 소개 - 학술 및 기술 글쓰기를 위한 유일한 AI 툴');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka는 학술 및 기술 글쓰기를 위한 유일한 툴입니다.이나고의 비전은 소통을 가로막는 언어와 글쓰기의 장벽을 허물어 주는 것입니다.' });
    this.metaTagService.updateTag({ name: 'keywords', content: '학술 및 기술 글쓰기 문법 검사기, 학술적 글쓰기 지원, 기술적 글쓰기 지원, 고급 문법 검사, 자동 문법 검사기' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka 소개 - 학술 및 기술 글쓰기를 위한 유일한 AI 툴' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka는 학술 및 기술 글쓰기를 위한 유일한 툴입니다.이나고의 비전은 소통을 가로막는 언어와 글쓰기의 장벽을 허물어 주는 것입니다.' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/aboutus' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/aboutus'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/aboutus'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/aboutus' });
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../assets/js/about_us_testimonial_silders.js', function () { });
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
    
  }
  ngAfterViewInit(){
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/branding_logo.js', function () { });
    }
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
